import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetTimestamp: Number
  }

  connect() {
    this.render()
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.stopTimer()
    this.timer = setInterval(() => this.render(), 1000)
  }

  stopTimer() {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
  }

  render() {
    if (!this.hasTargetTimestampValue) return

    const remainingSeconds = this.remainingSeconds()
    const minutes = Math.floor(remainingSeconds / 60)
    const seconds = remainingSeconds % 60

    this.element.textContent = `${minutes}m ${seconds}s`
  }

  remainingSeconds() {
    const targetTimestamp = Math.floor(this.targetTimestampValue / 1000) * 1000
    return Math.max(0, Math.ceil((targetTimestamp - Date.now()) / 1000))
  }
}
